import { render } from "./InputBelongsTo.vue?vue&type=template&id=49b08c55"
import script from "./InputBelongsTo.vue?vue&type=script&lang=js"
export * from "./InputBelongsTo.vue?vue&type=script&lang=js"

import "./InputBelongsTo.vue?vue&type=style&index=0&id=49b08c55&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__